export default "__VITE_ASSET__BCfPzQ8I__"